import React from 'react'
import { useTranslations } from '../../utils/hooks'
import ToggleWithLabel from './../../components/ToggleWithLabel/ToggleWithLabel'

const CompanyRPMTab = ({ companySettings, updateCompanySettings, currentUser }) => {
  const [t] = useTranslations()
  return (
    <>
      { currentUser.company === 'ID Plans' &&
        <ToggleWithLabel 
          titleLabel={t('CompanyRPMTab.disableRPM.title')} 
          titleDescriptions={[t('CompanyRPMTab.disableRPM.description')]} 
          ids={['disableRPM']}
          getObject={companySettings}
          getKeys={['rpmSettings.disableRPM']}
          updateFunction={updateCompanySettings} 
        />
      }
      { currentUser.company === 'ID Plans' && !!currentUser.companyAdmin &&
        <ToggleWithLabel 
          titleLabel={t('CompanyRPMTab.enableRiverside.title')} 
          titleDescriptions={[t('CompanyRPMTab.enableRiverside.description')]} 
          ids={['enableRiverside']}
          getObject={companySettings}
          getKeys={['rpmSettings.riversideEnabled']}
          updateFunction={updateCompanySettings}
        />
      }
      <ToggleWithLabel
        titleLabel={t('CompanyRPMTab.enableAssetPhotos.title')}
        titleDescriptions={[t('CompanyRPMTab.enableAssetPhotos.description')]}
        ids={['enableAssetPhotos']}
        getObject={companySettings}
        getKeys={['rpmSettings.enableAssetPhotos']}
        updateFunction={updateCompanySettings}
      />
      <ToggleWithLabel 
        titleLabel={t('CompanyRPMTab.enableSustainability.title')} 
        titleDescriptions={[t('CompanyRPMTab.enableSustainability.description')]} 
        ids={['enableSustainability']}
        getObject={companySettings}
        getKeys={['rpmSettings.sustainabilityEnabled']}
        updateFunction={updateCompanySettings}
      />
    </>
  )
}

export default CompanyRPMTab